package com.esoris.kmpmoout.core.appdefaultvalue

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

object AppDefault {

    val verticalArrangment = Arrangement.spacedBy(20.dp)
    val verticalArrangmentLarge = Arrangement.spacedBy(30.dp)
    val horizontalArrangment = Arrangement.spacedBy(10.dp)
    val horizontalArrangmentLarge = Arrangement.spacedBy(15.dp)

    val contentPadding = PaddingValues(horizontal = 16.dp, vertical = 16.dp)

    val paddingSmall: Dp = 8.dp
    val paddingMedium: Dp = 16.dp
    val paddingLarge: Dp = 24.dp

    val shape = RoundedCornerShape(16.dp)

    @Composable
    fun SpacerVertical(padding: Dp = AppDefault.paddingMedium) {
        Spacer(modifier = Modifier.height(padding))
    }

    @Composable
    fun SpacerHorizontal(padding: Dp = AppDefault.paddingMedium) {
        Spacer(modifier = Modifier.size(padding))
    }
}

@Composable
fun AppSpacer(height: Dp = AppDefault.paddingMedium, modifier: Modifier = Modifier,) {
    Spacer(modifier = modifier.height(height))
}

@Composable
fun AppSpacerHorizontal(modifier: Modifier = Modifier, width: Dp = AppDefault.paddingMedium) {
    Spacer(modifier = modifier.size(width))
}


